<script setup lang="ts">
import BoNoticeDocVarField from '../BoNoticeDocVarField.vue';
import BoNoticeSigners from './BoNoticeSigners.vue';

withDefaults(defineProps<{
  /** 문서별 싸인대상 Signers 키 (보통 docCode) */
  varKey?: string;
  /** 문서별 designation 필드 키 */
  designationKey?: string;
}>(), {
  varKey: 'notice',
  designationKey: 'signer_designation',
});
</script>

<template>
  <div class="bo-letter-close">
    <p class="doc-p" style="padding-top:10px">Yours faithfully,</p>
    <BoNoticeSigners :var-key="varKey" />
    <p class="doc-p" style="padding-top:4px">
      <BoNoticeDocVarField :field-key="designationKey" /><br />
      For and on behalf of<br />
      <BoNoticeDocVarField field-key="company_name" />
      (Company Registration No. <BoNoticeDocVarField field-key="company_registration_no" />)
    </p>
  </div>
</template>
